"use client";
import { useEffect, useState } from "react";

const RotatingGlobeEmoji = () => {
  const [globe, setGlobe] = useState(0);

  useEffect(() => {
    const globeRotate = setInterval(() => {
      setGlobe((globe) => globe + 1);
    }, 1500);

    return () => clearInterval(globeRotate);
  }, []);

  switch (globe % 3) {
    case 0:
      return <span className="mr-1">🌎</span>;
    case 1:
      return <span className="mr-1">🌏</span>;
    case 2:
      return <span className="mr-1">🌍</span>;
    default:
      return <span className="mr-1">🌎</span>; // As a fallback, if nothing matches
  }
};

export default RotatingGlobeEmoji;
